import { addReveniuSubscription } from "~/context/ReveniuSubscriptions/application/addReveniuSubscription";
import { VectiResult } from "~/context/Shared/domain/VectiResult";
import { Dependencies } from "~/context/Shared/infrastructure/Dependencies";
import { addSubscription } from "~/context/Subscriptions/application/addSubscription";
import { getDaysSubscriptionEnds } from "~/context/Subscriptions/application/getDaysSubscriptionEnds";
import { listSubscriptions } from "~/context/Subscriptions/application/listReveniuSubscription";

export async function saveSubscription(
  companyId: string,
  type: string,
): Promise<VectiResult> {


  const vectiResult = await addSubscription(
    Dependencies.getInstance().getSubscriptionRepository(),
    companyId,
    type
  );
  console.log("addSpotExpaddSubscriptionense: vectiResult: ", JSON.stringify(vectiResult));
  return vectiResult;
}

export async function saveSubscriptionReveniu(
  subscriptionId: string,
  companyId: string,
  type: string,
): Promise<VectiResult> {
  const vectiResult = await addReveniuSubscription(
    Dependencies.getInstance().getReveniuSubscriptionRepository(),
    subscriptionId,
    companyId,
    type
  );
  console.log("saveReveniuSubscription: vectiResult: ", JSON.stringify(vectiResult));
  return vectiResult;
}

export async function listActiveSubscriptions(
  companyId: string,
): Promise<VectiResult> {
  const vectiResult = await listSubscriptions(
    Dependencies.getInstance().getSubscriptionRepository(),
    companyId,
  );
  console.log("listActiveSubscriptions: vectiResult: ", JSON.stringify(vectiResult));
  return vectiResult;
}


export async function getDaysEndSubscription(companyId: string): Promise<VectiResult> {
  const vectiResult = await getDaysSubscriptionEnds(
    Dependencies.getInstance().getSubscriptionRepository(),
    companyId,
  );
  console.log("getDaysEndSubscription: vectiResult: ", JSON.stringify(vectiResult));
  return vectiResult;
}
